// react
import { useContext } from 'react';

// context
import { ContextIfrs } from '../../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableIfrs } from '../../../../../tables/cards/TableIfrs/TableIfrs';

export const Reports = () => {
	// context
	const { ifrs, isLoadingIfrs, paginationIfrs } = useContext(ContextIfrs);

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Container maxWidth={false}>
					<TableIfrs ifrs={ifrs} isLoading={isLoadingIfrs} pagination={paginationIfrs} />
				</Container>
			</Grid>
		</Grid>
	);
};
